import { makeStyles } from "@material-ui/core";

export default makeStyles({
  // Universal for Desktop and Mobile View
  infoIcon: {
    color: "black",
  },
});
